import store from "@/store";

export default [
	{
		path: '/debug/game/trick-selector/complete',
		async beforeEnter(to, from, next) {
			await store.dispatch("game/scores/calculate");
			await store.dispatch("game/performance/complete");
			await store.dispatch("game/balance/calculate");
			await store.dispatch("game/budgets/reset");
			next({ path: "/game/chapters/complete" });
		},
	},
	{
		name: "debug",
		path: '/debug*',
		redirect: (to) => {
			store.dispatch("global/debug/activate");
			return { path: to.params.pathMatch };
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/debug.routes.js